import { makeResetStyles, makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens, typographyStyles } from '@fluentui-copilot/tokens';
import type { SlotClassNames } from '@fluentui/react-components';
import type { EditorInputSlots, EditorInputState } from './EditorInput.types';

export const editorInputClassNames: SlotClassNames<EditorInputSlots> = {
  root: 'fai-EditorInput',
  input: 'fai-EditorInput__input',
  placeholderValue: 'fai-EditorInput__placeholderValue',
};

/**
 * Styles for the root slot
 */
const useRootClassName = makeResetStyles({
  display: 'inline-grid',
  whiteSpace: 'pre-wrap',
});

export const useLexicalStyles = makeStyles({
  paragraph: {
    margin: 0,
    textAlign: 'start',
  },
});

export const usePlaceholderClassName = makeResetStyles({
  zIndex: 0,
  gridArea: '1 / 1 / 1 / 1',

  color: tokens.colorNeutralForeground4,
  ...typographyStyles.body1,

  '@media (forced-colors: active)': {
    color: 'GrayText',
  },
});

export const useInputClassName = makeResetStyles({
  gridArea: '1 / 1 / 1 / 1',
  zIndex: 1,
  width: '100%',
});

const useStyles = makeStyles({
  placeholderDisabled: {
    color: tokens.colorNeutralForegroundDisabled,
  },
});
/**
 * Apply styling to the EditorInput slots based on the state
 */
export const useEditorInputStyles_unstable = (state: EditorInputState): EditorInputState => {
  'use no memo';

  const { disabled } = state;
  const placeholderClassName = usePlaceholderClassName();
  const rootClassName = useRootClassName();
  const inputClassName = useInputClassName();
  const styles = useStyles();

  state.root.className = mergeClasses(editorInputClassNames.root, rootClassName, state.root.className);

  state.input.className = mergeClasses(editorInputClassNames.input, inputClassName, state.input.className);

  if (state.placeholderValue) {
    state.placeholderValue.className = mergeClasses(
      editorInputClassNames.placeholderValue,
      placeholderClassName,
      disabled && styles.placeholderDisabled,
      state.placeholderValue.className,
    );
  }

  return state;
};
